// «Kartalarim» kesh kalitlari.
//
// ⚠️ PREFIKS `cashdesk` DAN VA `partnerAccount` DAN AJRALGAN. Kassa har
// pul amalidan keyin butun `['cashdesk']` shoxini bekor qiladi
// (`useCashOperation`) — kartalar ro'yxati esa pul amalidan
// O'ZGARMAYDI: vaucher ledgerga umuman tushmaydi. Umumiy prefiksda
// bo'lsa har to'ldirish ikkita keraksiz so'rov qo'shardi.
//
// ⛔ KODLAR RO'YXATI BU YERDA YO'Q va bo'lmaydi ham. Kod — bearer sir
// (`voucherStockApi.ts` dagi `fetchMyBatchCodes` izohi): kalit berilsa u
// `queryClient` ga tushardi va oyna yopilgandan keyin ham xotirada,
// DevTools'da ko'rinadigan holda yashardi.

export const voucherStockKeys = {
  all: ['voucherStock'] as const,
  /**
   * ⚠️ QIDIRUV VA SAHIFA KALITDA. Bittasi tushib qolsa TanStack Query
   * o'sha kalit uchun saqlangan ESKI javobni qaytaradi va yangisini
   * so'ramaydi — jadval qidiruvga umuman javob bermayotgandek
   * ko'rinardi, tarmoqda esa hech narsa yo'q (`profileKeys` dagi ayni
   * o'lchangan tuzoq).
   */
  batches: (search: string, page: number) =>
    ['voucherStock', 'batches', search.trim(), page] as const,
  /**
   * ⚠️ DAVR KALITDA — usiz sana filtri o'zgarganda ekranda oldingi
   * davrning ro'yxati qolib ketardi va u ishonarli ko'rinardi.
   */
  activations: (window: { from: string; to: string }, page: number) =>
    ['voucherStock', 'activations', window.from, window.to, page] as const,
} as const
